import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Grid, Divider } from '@material-ui/core';
import { InfoWidget } from '@ds/react-components';
import moment from 'moment';

const styles = (theme) => ({
  root: {},
  name: {
    marginBottom: 20,
  },
  data: {
    minHeight: 40,
  },
  dataLeft: {
    '& p': {
      color: theme.palette.common.lightText,
    },
  },
  dataRight: {
    '& p': {
      color: theme.palette.common.black,
    },
    textAlign: 'right',
  },
  divider: {
    marginBottom: 20,
  },
  icon: {
    fontSize: 18,
    verticalAlign: 'text-top',
  },
  expandable: {
    cursor: 'pointer',
    '& svg': {
      marginRight: '-5px',
      marginLeft: 5,
      marginTop: 2,
    },
    '& a': {
      textDecoration: 'underline',
    },
  },
  indent: {
    padding: '10px 18px',
    '& a': {
      textDecoration: 'underline',
    },
    backgroundColor: '#f9fcfd',
  },
  copyButton: {
    padding: 0,
    marginLeft: 3,
    '& svg path': {
      fill: theme.palette.common.darkerText,
    },
  },
  tags: {
    display: 'flex',
    '& span': {
      marginRight: 5,
    },
  },
});

class AccountDetails extends React.Component {
  render() {
    const { classes, localisation, profileDetails } = this.props;
    const { dateFormat } = localisation.locales;
    const dobStr =
      profileDetails &&
      profileDetails.dob &&
      moment(profileDetails.dob).format(dateFormat);

    return (
      <InfoWidget
        title={'Account Details'}
        isLoading={!profileDetails.hasOwnProperty('firstName')}
        classes={{ root: classes.root }}>
        <Grid container className={classes.data}>
          <Grid item xs={6} className={classes.dataLeft}>
            <Typography>First name</Typography>
          </Grid>
          <Grid item xs={6} className={classes.dataRight}>
            <Typography>{profileDetails.firstName}</Typography>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />

        {profileDetails.middleName && (
          <div>
            {' '}
            <Grid container className={classes.data}>
              <Grid item xs={6} className={classes.dataLeft}>
                <Typography>Middle Name</Typography>
              </Grid>
              <Grid item xs={6} className={classes.dataRight}>
                <Typography>{profileDetails.middleName}</Typography>
              </Grid>
            </Grid>
            <Divider className={classes.divider} />
          </div>
        )}

        <Grid container className={classes.data}>
          <Grid item xs={6} className={classes.dataLeft}>
            <Typography>Last name</Typography>
          </Grid>
          <Grid item xs={6} className={classes.dataRight}>
            <Typography>{profileDetails.lastName}</Typography>
          </Grid>
        </Grid>
        <Divider className={classes.divider} />

        <Grid container className={classes.data}>
          <Grid item xs={6} className={classes.dataLeft}>
            <Typography>Date of birth</Typography>
          </Grid>
          <Grid item xs={6} className={classes.dataRight}>
            <Typography>{dobStr}</Typography>
          </Grid>
        </Grid>

        <Divider className={classes.divider} />
        <Grid container className={classes.data}>
          <Grid item xs={6} className={classes.dataLeft}>
            <Typography>Debitsuccess ID</Typography>
          </Grid>
          <Grid item xs={6} className={classes.dataRight}>
            <Typography>{profileDetails.adfitNo}</Typography>
          </Grid>
        </Grid>
      </InfoWidget>
    );
  }
}
AccountDetails.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccountDetails);
